import "./sprinkles.css.ts.vanilla.css-mistica.js";
var f = "_1y2v1nfeb _1y2v1nfeq _1y2v1nfb7 _1y2v1nf5y _1y2v1nfdk _1y2v1nfdl _1y2v1nffz";
export { f as video };
